import { create } from 'zustand';
import { applicationService } from 'src/services/application';
import { ACCEPTANCE_WARNING_LS_KEY } from 'src/constants';
import { useApplicationStore } from './application';

interface AcceptanceChangeState {
  isModalOpen: boolean;
  isApplicationAccepted: boolean;

  // Actions
  setModalOpen: (isOpen: boolean) => void;
  setApplicationAccepted: (accepted: boolean) => void;
  resetAcceptance: () => Promise<void>;
  checkApplicationStatus: (openModal?: boolean) => Promise<boolean>;
  setDontShowAgain: () => void;
}

export const useAcceptanceChangeStore = create<AcceptanceChangeState>((set, get) => ({
  isModalOpen: false,
  isApplicationAccepted: false,

  setModalOpen: (isOpen: boolean) => {
    set({ isModalOpen: isOpen });
  },

  setApplicationAccepted: (accepted: boolean) => {
    set({ isApplicationAccepted: accepted });
  },

  setDontShowAgain: () => {
    try {
      localStorage.setItem(ACCEPTANCE_WARNING_LS_KEY, '1');
    } catch (error) {
      console.error('Failed to save dont show again preference:', error);
    }
    set({ isModalOpen: false });
  },

  resetAcceptance: async () => {
    try {
      await applicationService.resetAcceptance();
      await useApplicationStore.getState().updateTierFromApplicationState();
      await useApplicationStore.getState().getCurrentApplication();
      useApplicationStore.getState().clearMedicalPlan();
      set({ isApplicationAccepted: false, isModalOpen: false });
    } catch (error) {
      console.error('Failed to reset acceptance:', error);
      throw error;
    }
  },

  checkApplicationStatus: async (openModal: boolean = false) => {
    try {
      const applicationState = await applicationService.applicationState();
      // Check if user has disabled the modal
      const hideModal = typeof window !== 'undefined' && localStorage.getItem(ACCEPTANCE_WARNING_LS_KEY) === '1';
      // Check if phqAcceptedAt is not null
      const isAccepted = !!applicationState?.phqAcceptedAt;
      set({
        isApplicationAccepted: isAccepted,
        isModalOpen: isAccepted && !hideModal && openModal
      });
      return isAccepted;
    } catch (error) {
      console.error('Failed to check application status:', error);
      set({ isApplicationAccepted: false, isModalOpen: false });
      return false;
    }
  },
}));
